import { IDashboardArgs } from '../types/dashboard-types';

export class DashboardTaskDataMapper {
  static generateTaskSummaryTable(
    nameCaption: string,
    title: string,
    summaryData: any[],
    dashboardArgs: IDashboardArgs
    ): { data: any[]; columns: { dataField: string; caption: string; visible?: boolean }[]; title: string } {

      // Define columns for the table
    const columns = [
      { dataField: 'name', caption: nameCaption },
      { dataField: 'totalCount', caption: 'Total', cellTemplate: 'clickableCell' },
      { dataField: 'openCount', caption: 'Open', cellTemplate: 'clickableCell' },
      { dataField: 'pendingCount', caption: 'Pending', cellTemplate: 'clickableCell' },
      { dataField: 'holdCount', caption: 'On Hold', cellTemplate: 'clickableCell' },
      { dataField: 'overDueCount', caption: 'Overdue', cellTemplate: 'clickableCell' },
      { dataField: 'rejectedCount', caption: 'Rejected', cellTemplate: 'clickableCell', visible: dashboardArgs.showRejected },
      { dataField: 'completedCount', caption: 'Completed', cellTemplate: 'clickableCell', visible: !dashboardArgs.showOpen },
      { dataField: 'cancelledCount', caption: 'Cancelled', cellTemplate: 'clickableCell', visible: !dashboardArgs.showOpen },

    ];

    // Return the data in the required format
    return {
      data: summaryData,
      columns: columns,
      title: title,
    };
  }
}
